/** Pull a human-readable message out of an axios error. */
export function formatApiError(err: any, fallback: string): string {
  if (!err) return fallback;
  // No HTTP response at all → network / CORS / DNS / connection refused.
  if (!err.response) {
    const m = err.message || 'network error';
    return `Сеть: ${m}`;
  }
  const { status, data } = err.response;
  let body: string;
  if (typeof data === 'string') {
    body = data;
  } else if (data && typeof data.detail === 'string') {
    body = data.detail;
  } else if (data && Array.isArray(data.detail)) {
    body = data.detail.map((d: any) => d.msg || JSON.stringify(d)).join('; ');
  } else if (data) {
    try {
      body = JSON.stringify(data).slice(0, 300);
    } catch {
      body = fallback;
    }
  } else {
    body = fallback;
  }
  return `[${status}] ${body}`;
}
